module.exports = __webpack_public_path__ + "assets/images/rbyearend-19-desktop.jpg?v=1c5dd1b9";